import { createAsyncThunk } from '@reduxjs/toolkit';
import { projectApi } from 'container/projectApi';
import { pulseProjectApi } from 'container/pulseProjectApi';
import { selectCurrentProjectId } from 'reduxStore/project/projectSelector';
import { serializeError } from 'shared/utils/redux';

import { STORE_NAME } from './initialState';

export const COPY_SOURCES_PAGE_LIMIT = 10;

export const fetchCopySources = createAsyncThunk(
  `${STORE_NAME}/fetchCopySources`,
  ({ page }: { page: number }, { getState }) =>
    pulseProjectApi.listCopySources(selectCurrentProjectId(getState()), {
      page,
      limit: COPY_SOURCES_PAGE_LIMIT,
    }),
  { serializeError },
);

export const fetchCopyPreview = createAsyncThunk(
  `${STORE_NAME}/fetchCopyPreview`,
  ({ sourceId }: { sourceId: number }) => projectApi.get(sourceId),
  { serializeError },
);

export const createSurveyFromPreviousSurvey = createAsyncThunk(
  `${STORE_NAME}/createSurveyFromPreviousSurvey`,
  ({ sourceId }: { sourceId: number }, { getState }) =>
    pulseProjectApi.createFromPreviousSurvey(selectCurrentProjectId(getState()), sourceId),
  { serializeError },
);
